<span *ngIf="sum"
      class="adjustment"
      [class.positive]="sum > 0"
      [class.negative]="sum < 0"
      [title]="sum > 0 ? 'добавлено корректировкой' : 'вычтено корректировкой'"
>({{ sum|humanNumber:0:true }} <span class="currency">₽</span>)</span>
